// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Partial from "../Partial/index.js";
var unsafePartial = $foreign["_unsafePartial"];
var unsafeCrashWith = function (msg) {
    return unsafePartial(function () {
        return Partial.crashWith()(msg);
    });
};
export {
    unsafePartial,
    unsafeCrashWith
};
//# sourceMappingURL=index.js.map
